var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoReocrds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 248.549,
    height: 235.144,
    viewBox: "0 0 248.549 235.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7701",
    "data-name": "Group 7701",
    transform: "translate(-677.216 -532.235)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-records-324681",
    transform: "translate(678.143 588.504)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160520",
    "data-name": "Path 160520",
    d: "M185.717,31.036l-.746-.787h-3.711l.827-6.737a3.092,3.092,0,0,0-.766-2.34,3.027,3.027,0,0,0-2.259-1.009h-4.922V13.085a3.013,3.013,0,0,0-3.005-3.005h-5.063V3a3.013,3.013,0,0,0-3.005-3.005H88.417A3.013,3.013,0,0,0,85.412,3v7.08H80.349a3.013,3.013,0,0,0-3.005,3.006v7.079H72.422a3.025,3.025,0,0,0-2.259,1.009,3.073,3.073,0,0,0-.766,2.38l.827,6.7H67.461a2.174,2.174,0,0,0-1.674.787l-.625.827L77.183,116.3a3.287,3.287,0,0,0,3.227,2.7h90.644a3.3,3.3,0,0,0,3.247-2.783l11.88-83.4a2.151,2.151,0,0,0-.464-1.775ZM89.446,4.029h72.613V10.08H89.446ZM81.378,14.114h88.748v6.051H81.378ZM73.532,24.2h104.4l-.746,6.051H74.278Zm96.9,90.765H81.074l-11.5-80.679H181.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_160521",
    "data-name": "Path 160521",
    d: "M387.965,167.929c3.944.516,8.329,2.132,12.818,3.294,5.936,1.536,11.784,3.418,17.724,4.944a8.185,8.185,0,0,1,5.217,3.641c2.467,4.063,5.569,8.041,6.757,12.5s3.472,4.6,6.859,4.236c6.557-.707,11.783,1.709,16.01,6.682,2.373,2.792,4.934,5.425,7.436,8.105.968,1.036,1.679,2.346.557,3.374s-2.153-.139-2.979-1.023c-2.91-3.113-5.852-6.2-8.719-9.349a11.9,11.9,0,0,0-10.282-4.288,24.981,24.981,0,0,1-5.352-.017c-2.7-.359-3.619.89-4.127,3.337-.35,1.694.014,2.176,1.482,3.087,4.418,2.742,6.476,7.344,8.187,12.019.483,1.321-.632,1.884-1.915,1.963a12.742,12.742,0,0,1-5.725-1.422,88.578,88.578,0,0,0-14.192-4.3c-.742-.175-1.659-.722-2.112.186-.377.755.3,1.518.817,2.1,1.833,2.029,4.333,3.121,6.613,4.495a108.4,108.4,0,0,1,13.832,9.211,25.947,25.947,0,0,0,9.652,5.136c2.365.659,4.667,1.616,7.234.659a1.765,1.765,0,0,1,2.573,1.253c.3,1.265-.589,1.755-1.527,2.2-2.961,1.4-5.848.376-8.7-.353-6.421-1.644-11.418-5.8-16.614-9.6-.878-.641-1.778-1.26-2.71-1.818-3.558-2.132-3.583-2.127-4.718,1.981-.737,2.669-1.346,5.374-2.124,8.03-2.055,7.006-7.688,7.549-12.994,5.67a1.749,1.749,0,0,1-1.131-2.394c.309-1.064,1.15-1.1,2.14-1.038,7.156.437,7.169.422,9.251-6.61.786-2.654,1.458-5.342,2.258-7.992a2.037,2.037,0,0,0-1.215-2.824c-2.675-1.376-5.078-3.126-6.165-6.147-1.341-3.727.293-6.055,4.211-6.062a17.582,17.582,0,0,1,5.221,1.033c1.513.467,2.237-.135,2.61-1.517q1.74-6.445,3.5-12.887a5.508,5.508,0,0,0,.135-.578c.694-4.313-7.338-16.45-11.589-17.613q-12.88-3.524-25.737-7.139c-4.561-1.285-6.3-.415-7.785,4.181-1.888,5.84-3.71,11.7-5.618,17.535-.411,1.254-.732,3.059-2.678,2.351-1.683-.613-1.394-2.063-.912-3.526,2.074-6.3,4.028-12.64,6.105-18.939C380.793,169.889,383.565,167.9,387.965,167.929Z",
    transform: "translate(463.85 387.157)",
    fill: "#181818",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7700",
    "data-name": "Group 7700",
    transform: "translate(-86 101.554) rotate(-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7698",
    "data-name": "Group 7698",
    transform: "translate(555.094 304.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160522",
    "data-name": "Path 160522",
    d: "M180.279,452.533c-3.846.017-6.342-1.362-7.85-4.294q-12.3-23.91-24.528-47.853a7.976,7.976,0,0,1,3.362-11.019q17.276-9.181,34.6-18.265a16.325,16.325,0,0,1,1.887-.9,1.661,1.661,0,0,1,2.216.966,1.579,1.579,0,0,1-.645,2.1c-1.351.84-2.74,1.624-4.145,2.37Q169.747,383.827,154.3,392c-3.946,2.091-4.539,3.765-2.552,7.659q11.745,23.018,23.551,46c1.713,3.336,3.6,4.031,7.1,2.232q17.4-8.952,34.674-18.131c2.8-1.483,3.409-3.643,2.053-6.493-.982-2.065-2.117-4.058-3.214-6.067-.61-1.117-.65-2.217.533-2.828,1.265-.654,2.261-.107,2.885,1.208,1.069,2.249,2.273,4.435,3.3,6.7,1.871,4.134.616,8.681-3.378,10.8-12.055,6.386-24.21,12.581-36.329,18.846A5.138,5.138,0,0,1,180.279,452.533Z",
    fill: "#181818",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7699",
    "data-name": "Group 7699",
    transform: "translate(235.417 300.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160526",
    "data-name": "Path 160526",
    d: "M464.16,316.76a21.024,21.024,0,0,1,16.384,7.528c1.083,1.234,1.83,1.312,2.984.221,2-1.891,4.089-3.685,6.127-5.536.994-.9,2.094-1.526,3.2-.373,1.082,1.13.171,2.083-.654,2.868-2.068,1.969-4.093,4-6.3,5.8a3.261,3.261,0,0,0-1.223,4.171c4.342,13.471-2.9,25.982-16.706,29.118-8.463,1.922-17.522-1.987-22.671-9.782-4.786-7.244-4.644-17.7.333-24.507A21.766,21.766,0,0,1,464.16,316.76Z",
    transform: "translate(0)",
    fill: "#181818",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160527",
    "data-name": "Path 160527",
    d: "M483.015,334.632c4.323,8.641-.722,20.183-10.13,23.709-7.621,2.855-15.223.942-20.81-5.237-4.7-5.2-5.738-13.9-2.422-20.341a18.582,18.582,0,0,1,30.266-3.922c.951,1.026,1.476,1.93.191,3.084-4.246,3.811-8.488,7.627-12.682,11.495-1.094,1.009-1.6.14-2.223-.473-1.676-1.643-3.27-3.377-5.029-4.925-.868-.764-2.046-1.723-3.212-.473-1.1,1.185-.357,2.25.572,3.181,2.236,2.238,4.5,4.454,6.7,6.719,1.641,1.682,3.084,1.448,4.735-.082C473.592,343.088,478.293,338.9,483.015,334.632Z",
    transform: "translate(-2.286 -2.306)",
    fill: "#fafbfc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_160528",
    "data-name": "Path 160528",
    d: "M373.966,454.977a90.088,90.088,0,0,0,31.391-7.26c16.386-7.258,29.7-18.186,39.465-33.307.2-.3.442-.573.609-.889.771-1.46,1.936-2.342,3.487-1.432,1.63.956,1.14,2.365.288,3.719a87.523,87.523,0,0,1-15.426,18.819c-11.572,10.373-24.691,17.989-39.869,21.847a102.623,102.623,0,0,1-21.162,2.912c1.18,2.8,3.871,4.176,5.367,6.505.916,1.426,2.377,2.866.613,4.363-1.713,1.453-2.81-.34-3.825-1.416-2.872-3.045-5.608-6.222-8.531-9.218-1.974-2.022-1.3-3.59.466-5.144,3.138-2.766,6.31-5.495,9.43-8.282,1.254-1.12,2.606-2.128,4.013-.574s.187,2.806-.943,3.987C377.72,451.3,375.352,452.225,373.966,454.977Z",
    transform: "translate(381.397 376.601) rotate(-13)",
    fill: "#181818",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160529",
    "data-name": "Path 160529",
    d: "M8.794,43.258A90.087,90.087,0,0,0,40.185,36C56.571,28.74,69.888,17.812,79.65,2.691c.2-.3.442-.573.609-.889C81.029.341,82.194-.54,83.745.37c1.63.956,1.14,2.365.288,3.719A87.524,87.524,0,0,1,68.607,22.907C57.036,33.28,43.916,40.9,28.739,44.754A102.623,102.623,0,0,1,7.577,47.666c1.18,2.8,3.871,4.176,5.367,6.505.916,1.426,2.377,2.866.613,4.363-1.713,1.453-2.81-.34-3.825-1.416C6.859,54.073,4.123,50.9,1.2,47.9c-1.974-2.022-1.3-3.59.466-5.144,3.138-2.766,6.31-5.494,9.43-8.282,1.254-1.119,2.606-2.128,4.013-.574s.187,2.806-.943,3.987C12.548,39.58,10.18,40.506,8.794,43.258Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 796.504, 591.305)",
    fill: "#181818",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_303",
    "data-name": "Line 303",
    y1: 21,
    x2: 28.196,
    transform: "translate(732.304 727.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_304",
    "data-name": "Line 304",
    y1: 21,
    x2: 28.196,
    transform: "translate(727.304 720.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_305",
    "data-name": "Line 305",
    y1: 17,
    x2: 22.598,
    transform: "translate(721.902 716.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    y1: 10.5,
    x2: 14.495,
    transform: "translate(716.005 714.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    transform: "translate(732 693)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReocrds);
export default __webpack_public_path__ + "static/media/No Reocrds.14b11bc1a640f71e709d7306445fa1b5.svg";
export { ForwardRef as ReactComponent };